import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {
    findFollower,
    findHandler,
    getExtensionFile,
    getNameInCapitalize,
} from "../../utils/common";
import moment from "moment";
import { DATE_FORMAT_DEFAULT } from "../../utils/constants";
import {
    EmptyText,
    RichText,
    WordBreak,
} from "../../components/common/CellText";
import FileItem from "../../components/FileItemComponent/FileItem";
import LinkedTask from "../../components/Linked/LinkedTask";
import LinkedWork from "../../components/Linked/LinkedWork";
import PeopleTag from "../../components/PeopleTag";

const InformationModal = ({ open, handleClose, workDetail }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={"paper"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="doc-popup"
            fullWidth
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100vw",
                        maxWidth: "100vw", // Set your width here
                        mx: 0,
                    },
                },
            }}
        >
            <DialogTitle
                id="scroll-dialog-title"
                className="text-xl font-bold text-[#23374D] !pt-8"
                sx={{
                    fontWeight: 700,
                }}
            >
                <span className="font-bold">Thông tin</span>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                    className="min-h-[250px] mt-4"
                >
                    <div className="mt-4 mb-[6px] text-sm font-semibold leading-5 text-labelForm">
                        Người xử lý:
                    </div>
                    <div className="flex flex-wrap gap-3">
                        {findHandler(workDetail?.assignees)?.length>0 ? (
                            findHandler(workDetail?.assignees)?.map((item) => (
                                <PeopleTag el={item} />
                            ))
                        ) : (
                            <EmptyText>Không có</EmptyText>
                        )}
                    </div>
                    <div className="mt-4 mb-[6px] text-sm font-semibold leading-5 text-labelForm">
                        Người theo dõi:
                    </div>
                    <div className="flex flex-wrap gap-3">
                        {findFollower(workDetail?.assignees)?.length>0 ? (
                            findFollower(workDetail?.assignees)?.map((item) => (
                                <PeopleTag el={item} />
                            ))
                        ) : (
                            <EmptyText>Không có</EmptyText>
                        )}
                    </div>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button
                    sx={{ fontWeight: 600 }}
                    onClick={handleClose}
                    className="pb-6 text-sm font-semibold leading-5 text-primary"
                >
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InformationModal;
